import {
  NOT_CONFIRMED,
  CHIEF,
  ADMIN
} from '@lba-dev/package.local-globals/permissions';
import { S_RH } from '@lba-dev/package.local-globals/services';
import { permit } from '@lba-dev/package.local-globals/restrictions';

import componentLoader from '../../componentLoader';

const ListDemandes = componentLoader(() =>
  import(
    /* webpackChunkName: "ListDemandes" */
    '../../views/List/ListDemandes'
  )
);

const ListDevis = componentLoader(() =>
  import(
    /* webpackChunkName: "ListDevis" */
    '../../views/List/ListDevis'
  )
);

const AjoutDevis = componentLoader(() =>
  import(
    /* webpackChunkName: "AjoutDevis" */
    '../../views/AjoutDevis'
  )
);

export default [
  {
    path: '/devis/list/:filter/:query',
    component: ListDevis,
    restrictions: ({ service }) => ({
      [S_RH]: ADMIN,
    }[service] || NOT_CONFIRMED),
    redirectLink: () => '/',
  },
  {
    path: '/devis/list/:filter',
    component: ListDevis,
    restrictions: ({ service }) => ({
      [S_RH]: ADMIN,
    }[service] || NOT_CONFIRMED),
    redirectLink: () => '/',
  },
  {
    path: '/devis/list',
    component: ListDevis,
    restrictions: (user) =>
      permit(user, { key: 'devisListAccess' }) && user.auth,
    redirectLink: () => '/'
  },
  {
    path: '/devis/:id/:query',
    component: AjoutDevis,
    restrictions: ({ service }) => ({
      [S_RH]: ADMIN,
    }[service] || NOT_CONFIRMED),
    redirectLink: () => '/',
  },
  {
    path: '/devis/:id',
    component: AjoutDevis,
    restrictions: ({ service }) => ({
      [S_RH]: ADMIN,
    }[service] || NOT_CONFIRMED),
    redirectLink: () => '/',
  },
  {
    path: '/devis',
    component: AjoutDevis,
    restrictions: ({ service }) => ({
      [S_RH]: ADMIN,
    }[service] || NOT_CONFIRMED),
    redirectLink: () => '/',
  },
  {
    path: '/demandes/list/:filter/:query',
    component: ListDemandes,
    restrictions: ({ service }) => ({
      [S_RH]: ADMIN,
    }[service] || NOT_CONFIRMED),
    redirectLink: () => '/',
  },
  {
    path: '/demandes/list/:filter',
    component: ListDemandes,
    restrictions: ({ service }) => ({
      [S_RH]: ADMIN,
    }[service] || NOT_CONFIRMED),
    redirectLink: () => '/',
  },
  {
    path: '/demandes/list',
    component: ListDemandes,
    restrictions: ({ service }) => ({
      [S_RH]: ADMIN,
    }[service] || CHIEF),
    redirectLink: () => '/',
  },
];
